import EditPatientForm from './EditPatient';

export default EditPatientForm;
